export function InfoNosotros({ data }) {
    return (
        <div className='info container py-5 py-lg-0'>
            <div className='info__text'>
                <h2 className='info__title text-center mb-5'>{data.aboutUsTitle}</h2>
            </div>
            <div className='info__cards row justify-content-center'>
                {
                    data.aboutUsCards.map((item, index) => (
                        <CardNosotros
                            key={index}
                            data={item} />
                    ))
                }
            </div>
        </div>
    );
}

export function CardNosotros({ data }) {
    return (
        <div className='card-we col-md-4 mb-4'>
            <div className="card-we__image position-relative">
                <img className="card-we__img w-100" src={data.image} alt="Imagen para sección Nosotros" />
                <div className="card-we__overlay position-absolute w-100 h-100"></div>
            </div>
            <div className='card-we__text mt-4'>
                <h4 className='card-we__title text-center'>{data.title}</h4>
                <p className='card-we__description text-start'>{data.description}</p>
            </div>
        </div>
    );
}